import { useCallback, useState } from "react";
import { Trans, t } from "@lingui/macro";
import { PlayFilledAlt, VideoPlayer } from "@carbon/icons-react";
import { Box, Button, Checkbox, Container, Typography } from "@mui/material";
import OnboardingHeader from "@/components/Onboarding/OnboardingHeader";
import useVideoPlayer from "./useVideoPlayer";

function VideoIntroPage() {
  const { navToFirstVideo, tosText } = useVideoPlayer();
  const [termsAccepted, setTermsAccepted] = useState(false);
  const handleTermsClick = useCallback(() => {
    setTermsAccepted((prev) => !prev);
  }, []);

  return (
    <>
      <Container
        maxWidth="sm"
        disableGutters
        sx={{ height: "100%", display: "flex", flexDirection: "column" }}
      >
        <OnboardingHeader
          Icon={VideoPlayer}
          title={t`Take a guided tour`}
          subtitle={t`Lace up your running shoes, dive-in, and follow along your guided tour of your KICKR RUN.`}
        />
        <Box
          data-testid="onboarding.tosScrollBox"
          mt={1}
          mx={4}
          p={2}
          sx={{
            flex: 1,
            minHeight: 0,
            maxHeight: "42vh",
            overflowY: "auto",
            border: 1,
            borderColor: "divider",
            borderRadius: 1,
          }}
        >
          {tosText.map((paragraph: string, index: number) => (
            <Typography key={index} sx={{ mt: index === 0 ? 0 : 2 }}>
              {paragraph}
            </Typography>
          ))}
        </Box>
        <Box
          mt={2}
          mx={4}
          display="flex"
          alignItems="flex-start"
          gap={1}
          flexShrink={0}
          onClick={handleTermsClick}
        >
          <Checkbox sx={{ top: "-9px" }} checked={termsAccepted} />
          <Trans>
            I have reviewed the KICKR RUN instructional materials and agree to operate the KICKR RUN
            in accordance with the safety instructions.
          </Trans>
        </Box>
        <Box
          px={3}
          pt={2}
          pb="var(--wf-bottom-safe-area, 0px)"
          width="100%"
          maxWidth="sm"
          flexShrink={0}
        >
          <Button
            variant="contained"
            size="large"
            fullWidth
            disabled={!termsAccepted}
            onClick={navToFirstVideo}
          >
            <Box display="flex" gap={1} alignItems="center">
              <PlayFilledAlt />
              <Trans>Watch Video</Trans>
            </Box>
          </Button>
        </Box>
      </Container>
    </>
  );
}

export default VideoIntroPage;
